import { getAPIUrl } from "../config";

const API_URL = getAPIUrl()

const parseErrorResponse = async (response, fallbackMessage) => {
  let payload = null;

  try {
    payload = await response.json();
  } catch (error) {
    payload = null;
  }

  const error = new Error(payload?.error || fallbackMessage);
  error.code = payload?.code;
  error.status = response.status;
  throw error;
};

export const fetchTables = async (venueId, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();
  
      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/tables`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();

      if (!response.ok) {
        throw new Error('Failed to fetch tables');
      }
  
      return data;
    } catch (error) {
      console.error('Error fetching tables:', error);
      throw error;
    }
  };

  export const updateTables = async (venueId, updatedTables, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();

      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/tables`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(updatedTables)
      });

      if (!response.ok) {
        throw new Error('Failed to update tables');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating tables:', error);
      throw error;
    }
  };

  export const reorderTables = async (venueId, tablesWithOrder, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();
      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/tables/reorder`, {
        method: 'PUT',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ tables: tablesWithOrder })
      });
      
      if (!response.ok) {
        throw new Error('Failed to reorder tables');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Error reordering tables:', error);
      throw error;
    }
  };

  export const updateTable = async (venueId, table, getAccessTokenSilently) => {
    try {
      const token = await getAccessTokenSilently();

      const response = await fetch(`${API_URL}/api/v1/venues/${venueId}/tables/${table.id}`, {
        method: 'PATCH',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(table)
      });

      if (!response.ok) {
        await parseErrorResponse(response, 'Failed to update table');
      }

      return await response.json();
    } catch (error) {
      console.error('Error updating table:', error);
      throw error;
    }
  };
  
